import { render } from "./Messages.vue?vue&type=template&id=44984cc0&scoped=true&ts=true"
import script from "./Messages.vue?vue&type=script&lang=ts"
export * from "./Messages.vue?vue&type=script&lang=ts"

import "./Messages.vue?vue&type=style&index=0&id=44984cc0&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44984cc0"]])

export default __exports__